var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container has-text-centered"},[_c('div',{staticClass:"column is-4 is-offset-4"},[_c('h3',{staticClass:"title has-text-grey"},[_vm._v(_vm._s(_vm.estrategia.name))]),_c('login')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }